import SeoHead from '@/components/feature/SeoHead';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import RecentArticles from './components/RecentArticles';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <>
      <SeoHead
        title="首页"
        description="火影黄漫 - 正版资源导航与创作指南，汇聚火影忍者成人向同人漫画的资源导航、绘师创作技巧与同人社区推荐，帮助爱好者快速找到优质内容入口。"
        keywords="火影黄漫,火影忍者同人漫画,火影成人向同人,火影忍者R18同人,火影同人绘师,火影黄漫资源导航,火影同人创作指南"
        canonicalUrl="/"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '火影黄漫导航',
          url: 'https://huoying-doujin.com',
          description: '火影黄漫 - 正版资源导航与创作指南',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://huoying-doujin.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <RecentArticles />
        <FaqSection />
        <CtaSection />
      </main>
    </>
  );
}